import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Input } from '@hump/ui';
import { useKnowledgeStore } from '../stores/knowledge';
import { KnowledgeCard } from '../components/KnowledgeCard';

const filterTabs = [
  { id: 'all', label: '全部' },
  { id: 'word', label: '生词' },
  { id: 'snippet', label: '段落' },
  { id: 'note', label: '批注' },
] as const;

export function VocabPage() {
  const { t } = useTranslation();
  const { items, loading, filter, searchQuery, load, setFilter, setSearchQuery } = useKnowledgeStore();

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-serif text-camel-dark mb-1">
        {t('vocab.title')} 🐪
      </h1>
      {items.length > 0 && (
        <p className="text-sm text-charcoal/50 dark:text-charcoal-light/50 mb-4">
          {t('vocab.countText', { count: items.length })}
        </p>
      )}

      {/* 搜索 + 筛选 */}
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <div className="flex items-center gap-2 flex-1">
          <Search className="w-4 h-4 text-charcoal/40 dark:text-charcoal-light/40 shrink-0" />
          <Input
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={t('vocab.searchPlaceholder')}
            className="flex-1"
          />
        </div>
        <div className="flex gap-1 shrink-0">
          {filterTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setFilter(tab.id as 'all' | 'word' | 'snippet' | 'note')}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors ${
                filter === tab.id
                  ? 'bg-camel text-white'
                  : 'text-charcoal/60 dark:text-charcoal-light/60 hover:bg-warm-white dark:hover:bg-border-warm-dark'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* 列表 */}
      {loading ? (
        <p className="text-charcoal/50">{t('common.loading')}</p>
      ) : items.length === 0 ? (
        <div className="flex flex-col items-center py-20 gap-4">
          <p className="text-6xl">🐪</p>
          <p className="text-lg text-charcoal/60 dark:text-charcoal-light/60 text-center max-w-xs">
            {t('vocab.empty')}
          </p>
        </div>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2">
          {items.map((item) => (
            <KnowledgeCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
